import React from 'react';
import PropTypes from 'prop-types';
import HeaderNavMobile from './HeaderNavMobile';
import HeaderNavDesktop from './HeaderNavDesktop';

const HeaderNav = ({ children }) => <div className="c-header__main-nav">{children}</div>

HeaderNav.Mobile = HeaderNavMobile;
HeaderNav.Desktop = HeaderNavDesktop;

export default HeaderNav;

HeaderNav.propTypes = {
  children: PropTypes.node.isRequired,
};
